/**
 * create-basics — the beginner tour of the scenario editor.
 *
 * Bump `version` whenever the steps are reordered or removed. A tab that was
 * midway through an older version drops its saved session instead of resuming
 * into a step that has moved.
 */

import steps from './createBasics.steps';
import content from './createBasics.content';

const createBasics = {
    id: 'create-basics',
    // 2: the palette now opens with the editor, so the step that used to ask for
    // a click on it explains it instead, and the drag steps pin where nodes land.
    version: 2,
    title: 'Create your first scenario',
    /**
     * Offering the tour again after the one-time prompt has been spent. `from`
     * names the entry point it starts at, because a replay has to begin where
     * the first step expects to be: 'create' is the navbar's Create dialog.
     * Omit `replay` entirely and a tutorial simply is not offered a second time.
     */
    replay: { from: 'create', ...content.replay },
    /**
     * Areas of the app that go inert while this tutorial runs. A component asks
     * with `useTutorialLock('editor')`; a lock also covers anything beneath it,
     * so 'editor' locks 'editor.text' too.
     */
    locks: ['createModal', 'titlePage', 'editor', 'tags', 'canvas'],
    content,
    steps,
};

export default createBasics;
